import React, { Component } from 'react';
import DownloadButton from '../../utility/DownloadButton';
import ErrorMessage from '../../ErrorMessage';

export default class CSVDownloadButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errorMessage: null,
    };
  }

  async downloadCsv() {
    try {
      this.setState({ loading: true, errorMessage: null });
      const csvData = await this.props.csv();

      if (!csvData) {
        this.setState({
          errorMessage: 'No new users found',
        });
      } else {
        // https://stackoverflow.com/a/24643992
        const downloadLink = document.createElement('a');
        const blob = new Blob(['\ufeff', csvData]);
        const url = URL.createObjectURL(blob);
        downloadLink.href = url;
        downloadLink.download = `${this.props.filename}.csv`;
        downloadLink.id = `${this.props.filename}-hidden-download-link`;

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    } catch (e) {
      console.log(`Error when downloading CSV: ${e}`);
      this.setState({
        errorMessage: 'Error generating CSV',
      });
    } finally {
      this.setState({ loading: false });
    }
  }

  render() {
    return (
      <div className="csv-download-button">
        <button
          type="button"
          className="csv-download-button__button"
          id={`csv-download-button-${this.props.filename}`}
          onKeyDown={(e) => {
            if (['Enter'].includes(e.key)) this.downloadCsv();
          }}
          onClick={() => this.downloadCsv()}
          aria-label="Click to download CSV"
        >
          <span className="csv-download-button__text">
            {this.state.loading ? 'Downloading...' : 'Download CSV'}
          </span>
          <DownloadButton color={this.props.color} />
        </button>
        <ErrorMessage
          error={this.state.errorMessage}
          hidden={!this.state.errorMessage}
        />
      </div>
    );
  }
}
